"use client";

import { useEffect, useState, useRef } from "react";
import CountUp from "react-countup";

const milestones = [
  { label: "AI/ML Models Deployed", value: 100, suffix: "+" },
  { label: "Documents Analyzed", value: 5, suffix: "B+" },
  { label: "Hours of IoT Data Monitored", value: 10, suffix: "M+" },
  { label: "Videos Analyzed", value: 22, suffix: "k+" },
  { label: "Simulation Models Built", value: 70, suffix: "+" },
  { label: "Scenarios Analyzed", value: 753, suffix: "k+" },
];

export default function Milestones() {
  const [startCount, setStartCount] = useState(false);
  const milestonesRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (milestonesRef.current) {
      observer.observe(milestonesRef.current);
    }

    return () => {
      if (milestonesRef.current) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <div
      ref={milestonesRef}
      className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center mb-10"
    >
      {milestones.map((milestone, index) => (
        <div key={index} className="flex flex-col items-center">
          <span className="mb-5 font-mono text-shadow-[#06ff88]">
            {milestone.label}
          </span>
          <span className="text-4xl font-bold text-[#06ff88]">
            <CountUp
              start={startCount ? 0 : null}
              end={milestone.value}
              duration={4}
              separator=","
              suffix={milestone.suffix}
            />
          </span>
        </div>
      ))}
    </div>
  );
}
